import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { useRetrieveDivision, useRetrieveDivisionsBySeasonId, useUpdateDivision, } from "../api/DivisionApiProvider";
import { useRetrieveUserLeaguePermissions } from "../api/PermissionApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { DivisionForm } from "./DivisionForm";
export var UpdateDivision = function () {
    var _a = useNumericParams(), leagueId = _a.leagueId, seasonId = _a.seasonId, id = _a.id;
    var navigate = useNavigate();
    var _b = useRetrieveUserLeaguePermissions({ leagueId: leagueId }), permissions = _b.data, permissionsLoading = _b.isLoading, permissionsError = _b.error;
    var _c = (permissions || {}).canModify, canModify = _c === void 0 ? false : _c;
    var _d = useRetrieveDivision({ id: id }), division = _d.data, isLoading = _d.isLoading, error = _d.error;
    var _e = useRetrieveDivisionsBySeasonId({
        seasonId: division === null || division === void 0 ? void 0 : division.season,
        enabled: !!(division === null || division === void 0 ? void 0 : division.season) && canModify,
    }), _f = _e.data, divisions = _f === void 0 ? [] : _f, divisionsLoading = _e.isLoading;
    var mutation = useUpdateDivision({
        onMutate: function () { },
        onSuccess: function (data) {
            var updated = data.data;
            navigate("/leagues/".concat(leagueId, "/seasons/").concat(updated.season));
        },
        onError: function () { },
    });
    if (!id || !leagueId || !seasonId) {
        return (_jsx(ErrorView, { error: new Error("Missing division, league, or season id") }));
    }
    if (permissionsLoading ||
        isLoading ||
        mutation.isLoading ||
        divisionsLoading) {
        return _jsx(Loading, {});
    }
    if (permissionsError) {
        return _jsx(ErrorView, { error: permissionsError });
    }
    if (!canModify) {
        return _jsx(NotFound, {});
    }
    if (error || !division) {
        return _jsx(ErrorView, { error: error || new Error("Failed to load division") });
    }
    return (_jsxs(_Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update division. Please try again.", onClose: function () { } }), _jsx(DivisionForm, { onSubmit: function (data) { return mutation.mutate(data); }, seasonId: division.season, existingDivisions: divisions, division: division })] }));
};
